'use client';

import { config } from '@/constants/config';
import { cn } from '@/lib/utils';

export function EnvBanner() {
  const isProduction = config.env === 'production';

  if (isProduction) {
    return null;
  }

  const colorClass = {
    development: 'bg-violet-500',
    staging: 'bg-amber-500',
    production: '',
  } as const;

  const text = {
    development: 'Você está em modo desenvolvimento',
    staging: 'Você está em modo de staging',
    production: '',
  } as const;

  return (
    <>
      <div className="h-8" aria-hidden="true" />
      <div
        className={cn(
          'fixed top-0 right-0 left-0 z-50 flex h-8 items-center justify-center text-sm font-medium text-white shadow-sm',
          colorClass[config.env],
        )}
      >
        {text[config.env]}
      </div>
    </>
  );
}
